'use client'

import { createContext, useContext, useMemo } from 'react'
import type { Locale, ClientTranslations } from './locales'

interface LocaleContextValue {
  locale: Locale
  t: ClientTranslations
}

// Sem default estático: importar o dicionário pt-BR aqui arrastaria as ~460
// linhas para o client bundle de todas as páginas. O provider é sempre
// montado pelo layout público com as translations do servidor.
const LocaleContext = createContext<LocaleContextValue | null>(null)

export function LocaleProvider({
  locale,
  translations,
  children,
}: {
  locale: Locale
  translations: ClientTranslations
  children: React.ReactNode
}) {
  const value = useMemo(() => ({ locale, t: translations }), [locale, translations])
  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  )
}

export function useTranslations() {
  const ctx = useContext(LocaleContext)
  if (!ctx) throw new Error('useTranslations must be used within LocaleProvider')
  return ctx
}
